const groupsStr = {
  toastr: 'Deleted group',
  toastr1: 'successfully deleted'
};

export default groupsStr;
